import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../../utils/hooks/useAxios";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

export const useLookups = () => {
  const { axiosProtected } = useAxios();
  const { t } = useTranslation();

  return useQuery({
    onError: (err) => {
      toast.success(err?.message || t("LOOKUPS_FETCHED_FAILED"));
    },
    queryKey: ["lookups"],
    queryFn: () =>
      axiosProtected.get("lookup/multiple", {
        params: {
          keys: ["systems"].join(","),
        },
      }),
  });
};

export default useLookups;
